import type {
  ComponentMaterial,
  RecyclingStream,
} from '@/shared/hooks/api/packagingSuppliers'

const PLASTIC_RECYCLING_STREAMS: RecyclingStream[] = [
  'PLASTICS_HDPE',
  'PLASTICS_PET',
  'PLASTICS_PP',
  'PLASTICS_LDPE',
  'OTHER_RECYCLABLE_WASTE',
]

const PAPER_CARDBOARD_RECYCLING_STREAMS: RecyclingStream[] = [
  'PAPER_CARDBOARD',
  'OTHER_RECYCLABLE_WASTE',
]

const GLASS_RECYCLING_STREAMS: RecyclingStream[] = [
  'GLASS',
  'OTHER_RECYCLABLE_WASTE',
]

const OTHER_ONLY_RECYCLING_STREAMS: RecyclingStream[] = [
  'OTHER_RECYCLABLE_WASTE',
]

export const COMPONENT_MATERIAL_RECYCLING_STREAMS: Record<
  ComponentMaterial,
  RecyclingStream[]
> = {
  PLASTIC: PLASTIC_RECYCLING_STREAMS,
  PAPER_CARDBOARD: PAPER_CARDBOARD_RECYCLING_STREAMS,
  GLASS: GLASS_RECYCLING_STREAMS,
  METAL_ALUMINIUM: OTHER_ONLY_RECYCLING_STREAMS,
  METAL_STEEL: OTHER_ONLY_RECYCLING_STREAMS,
  WOOD: OTHER_ONLY_RECYCLING_STREAMS,
  OTHER: OTHER_ONLY_RECYCLING_STREAMS,
}

export function getAllowedRecyclingStreamsForMaterial(
  material: ComponentMaterial | null
): RecyclingStream[] {
  if (material === null) {
    return []
  }
  return COMPONENT_MATERIAL_RECYCLING_STREAMS[material]
}

export function isRecyclingStreamAllowedForMaterial(
  material: ComponentMaterial | null,
  stream: RecyclingStream | null | undefined
): boolean {
  if (stream === null || stream === undefined || stream === 'NONE') {
    return true
  }
  if (material === null) {
    return false
  }
  return COMPONENT_MATERIAL_RECYCLING_STREAMS[material].includes(stream)
}

export function coerceRecyclingStreamForMaterial(
  material: ComponentMaterial | null,
  stream: RecyclingStream | null | undefined
): RecyclingStream | null {
  if (stream === null || stream === undefined || stream === 'NONE') {
    return null
  }
  if (isRecyclingStreamAllowedForMaterial(material, stream)) {
    return stream
  }
  return null
}
